import { CssBaseline } from '@mui/material'
import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { DialogProvider, Header, Loader, ScrollToTop } from '../Components/Shared'

const PlainLayout: React.FC = () => {
  return (
    <DialogProvider>
      <CssBaseline />
      <Header sidebar={false} />
      <div style={{ marginTop: '4.5rem' }}>
        <Suspense fallback={<Loader />}>
          <div className='root'>
            <Loader />
            <Outlet />
            <ScrollToTop />
          </div>
        </Suspense>
      </div>
    </DialogProvider>
  )
}

export default PlainLayout
